import { SUPPORT } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const Support = (payload) => {
  return apiInstance.post(SUPPORT, payload);
};
